import { v4 } from 'uuid'
import { StatementTemplate } from 'store/products/types'
import { Template } from 'store/statement/types'

export default (template: StatementTemplate): Template => ({
  templateName: template?.name || '',
  templateGroupId: template?.id || v4(),
  isDefault: false,
})
